import { render } from "./App.vue?vue&type=template&id=4a1b4ce1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a1b4ce1&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__